<template>
  <!--我的訂單-->
  <div>
    <div class="loadingInf">
      <span>
        {{$t('mall_profile.my_cart')}} <!-- 我的購物袋 -->
      </span>
    </div>
    <div v-if="datalist&&datalist.length>0" class="scrollBox">
      <div class="selfOrder">
        <div class="orderList">
          <div v-for=" data in datalist" :key="data.id">
            <div style="width: 140px; padding: 20px 20px 20px 0">
              <div class="orderImg">
                <img :src="imgUrl + data.product_model.color_photo[0].path" alt="">
              </div>
            </div>

            <div class="orderDetail">
              <div class="delete" @click=" deleteOrder(data.id)"><span>&#10005</span></div>
              <div class="name">
                <span>{{data.product_model.default_name}}</span>
              </div>
              <div class="detail">
                <div class="left">
                  <div>
                    <span style="margin-right: 5px">
                      {{$t('mall_detail.color')}}<!-- 顏色 -->
                    </span>
                    <span>{{data.product_model.color_photo[0].color.name}}</span>
                  </div>
                  <div>
                    <span style="margin-right: 5px">
                      {{$t('mall_detail.size')}}<!-- 尺寸 -->
                    </span>
                    <span>{{data.product_size ? data.product_size : $t('mall_detail.free_size')}}</span>
                  </div>
                </div>
                <div class="price">
                  <span>${{data.product_model.areas[0].price | PriceFormat}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div class="total">
        <div style="color: black">
          {{$t('mall_cart.total')}}<!-- 合計 -->：
          $<span style="font-family: STSong;">{{getSun()|PriceFormat}}</span>
        </div>
        <div class="Settlement" @click="Settlements">
          {{$t('mall_cart.pay')}}<!-- 結算 -->
        </div>
      </div>
    </div>
    <div v-else class="defaultGraphs">
      <div class="emptyCart">
        {{$t('mall_cart.no_more')}}<!-- 您的購物車暫無商品 -->
      </div>
      <div class="shopping">
        <router-link :to="{name:'Search',query:{type:'reco'}}">
          {{$t('mall_cart.go_shop')}}<!-- 去選購商品 -->
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
  import ajax from "axios"
  import baseUrl from '@/api/baseUrl.js'
  import PriceFormat from "@/assets/js/PriceFormat"


  export default {
    name: "ShoppingCart",
    data() {
      return {
        datalist:null,
        imgUrl: baseUrl.imgUrl,
        checkgroub: [],
        item: "",
        type: '',
        orderData: [
          {
            product_model_id: '',
            product_color_id: '',
            product_size: '',
          }
        ],
      }
    },
    filters: {
      PriceFormat(val) {
        return PriceFormat(val);
      }
    },

    mounted() {
      this.getData();
      window.onscroll = this.handleScroll
    },

    methods: {
      getData() {
        this.$axios.get('api/app_v1/customer/shopping_cart_itemsV2', {
          headers: {
            'language': this.language
          }
        }).then(res => {
          this.datalist = res.data.data;
          // console.log("ssss", res.data.data)

        })
      },
      //函數計算中的狀態改變後，函數會自動執行壹遍
      getSun() {
        var sun = 0;
        for (var i in this.datalist) {
          sun += this.datalist[i].product_model.areas[0].price
        }
        return sun
      },
      //刪除商品
      deleteOrder(id) {
        this.$axios.delete("api/app_v1/customer/shopping_cart_items/" + id, {}).then(res => {
          this.$notify.success({
            message: this.$t('mall_detail.success_delete') //'刪除成功'
          });
          this.getData();
          this.$emit('refreshCart');
        });
      },

      Settlements() {
        let orderData = []
        if (this.datalist.length === 0) {
          this.$notify.info({
            message:  this.$t('mall_detail.cart_none')//'購物車為空'
          });
        } else {
          // console.log('jkkjkjk', this.datalist)
          this.datalist.forEach(row => {
            orderData.push({
              'product_model_id': row.product_model_id,
              'product_color_id': row.color_id,
              'product_size': row.product_size
            })
          });
          console.log("fadfksaf", orderData)
          this.$router.push({
            name: 'ConfirmOrder',
            query: {products: JSON.stringify(orderData)}
          });
        }


      }
    }
  }
</script>

<style scoped>
  .loadingInf {
    color: #1E1303;
    font-size: 18px;
    border-bottom: 1px solid #ddd;
    padding-bottom: 10px;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .total {
    color: #979694;
    font-size: 20px;
    padding: 0 20px 20px 20px;
    text-align: right;
  }

  .total .Settlement{
    display: inline-block;
    background: #1E1303;
    color: white;
    width: 90px;
    font-size: 14px;
    padding: 7px 0;
    text-align: center;
    cursor:pointer;
    margin-top: 30px;
  }

  .selfOrder {
    min-height: 650px;
    width: 100%;
    padding: 0 20px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    margin-bottom: 20px;
  }

  .scrollBox {
    position: relative;
    height: 85%;
  }

  .orderList {
    box-sizing: border-box;
    margin-bottom: 100px;
  }

  .orderList > div {
    display: flex;
    flex-direction: row;
  }

  .orderImg {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    width: 100%;
    border: 1px solid #ddd;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 10px;
    margin-right: 20px;
  }

  .orderImg > img {
    width: 100%;
  }

  .orderDetail {
    color: #979694;
    font-size: 14px;
    flex: 1;
    /*margin-right: 20px;*/
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    border-bottom: 1px solid #ddd;
    padding: 20px 0;
  }

  .orderDetail .name {
    color: #5B5957;
    font-size: 16px;
    display: flex;
    flex-direction: row;
    align-items: center;

  }

  .orderDetail .detail {
    display: flex;
  }

  .orderDetail .detail .left {
    flex: 3;
    padding-top: 30px;
  }

  .orderDetail .detail .price {
    padding: 4px 0;
    color: black;
    font-size: 20px;
    font-family: STSong;
    flex: 1;
    text-align: right;
  }

  .delete {
    padding-top:10px;
    width: 100%;
    cursor: pointer;
    height: 10px;
    color: #7A7977;
  }
  .delete>span {
    float: right;
    display: block;
    width: 10px;
    height: 10px;
    font-size: 10px;
    line-height: 1;
  }

  .defaultGraphs{
    text-align: center;

  }
  .emptyCart{
    margin: auto;
    font-size: 20px;
    font-family:PingFangSC-Regular;
    font-weight:400;
    color:rgba(30,19,3,1);
    letter-spacing:2px;
    padding-top: 281px;
  }
  .shopping{
    width: 121px;
    background: rgba(30,19,3,1);
    margin: 34px auto;
  }
  .shopping>a{
    font-size: 16px;
    color: rgba(255,255,255,1);
    text-align: center;
    display: block;
    padding: 11px 0;
  }
</style>



// WEBPACK FOOTER //
// src/views/viewHK/MyProfile/ShoppingCart.vue